// extracted by mini-css-extract-plugin
module.exports = {"offline-instruction":"sAToyS","offlineInstruction":"sAToyS"};